import { MainV3ApiBase } from './base';
import { EventIndexView, EventShowView } from '../types/events';
import { EventId } from '../../commonv3/types/events';

export const EventApis = {
    base() {
        return MainV3ApiBase.appendPath('events');
    },
    findAll(): Promise<EventIndexView[]> {
        return this.base().get();
    },
    find(eventId: EventId): Promise<EventShowView> {
        return this.base()
            .withId(eventId)
            .get();
    },
};
